import Description from './Description'
import { Contribution, Position, Role } from './Position'
import Resume from './Resume'

Resume.Contribution = Contribution
Resume.Description = Description
Resume.Position = Position
Resume.Role = Role

export default Resume
